export enum OnboardingWorkSituations {
  Student = 'student',
  Employed = 'employed',
  Freelancer = 'freelancer',
  Solopreneur = 'solopreneur',
  SmallBusinessOwner = 'small_business_owner',
  MediumBusinessOwner = 'medium_business_owner',
  LargeBusinessOwner = 'large_business_owner',
  Other = 'other',
}

export enum OnboardingHearAboutUs {
  AppStore = 'app_store',
  AiTools = 'ai_tools',
  FriendsOrFamily = 'friends_or_family',
  Instagram = 'instagram',
  Linkedin = 'linkedin',
  Facebook = 'facebook',
  Reddit = 'reddit',
  Tiktok = 'tiktok',
  Google = 'google',
  Youtube = 'youtube',
  Threads = 'threads',
  Toolfinder = 'toolfinder',
  Other = 'other',
}
